import type { Brand } from '../api/types.ts';

/** Static assets per brand live in public/brands/<id>/. */
export function brandLogo(brand: Pick<Brand, 'id'>): string {
  return `/brands/${brand.id}/logo.png`;
}

export function brandFavicon(brand: Pick<Brand, 'id'>): string {
  return `/brands/${brand.id}/favicon.png`;
}

/** Stamps the brand on the document: title, favicon and the data-brand attribute the stylesheet keys on. */
export function applyBrandToDocument(brand: Brand): void {
  document.title = `${brand.name} - My Account`;
  document.documentElement.dataset.brand = brand.id;
  const link = document.getElementById('favicon');
  if (link instanceof HTMLLinkElement) link.href = brandFavicon(brand);
}

/** Where a subscription is managed outside the app stores. */
export function manageSubscriptionUrl(brand: Pick<Brand, 'id'>): string | null {
  return brand.id === 'BL' || brand.id === 'BP' ? 'https://checkout.bluemail.me/p/login/3cs3dt1Ux4gP3PqcMM' : null;
}
